var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconlyLightSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.686,
    height: 25.229,
    viewBox: "0 0 24.686 25.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Search",
    "data-name": "Iconly/Light/Search",
    transform: "translate(-1.778 -1.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(2.778 2.778)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_739",
    cx: 10.669,
    cy: 10.669,
    r: 10.669,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_181",
    d: "M0,0,4.183,4.172",
    transform: "translate(18.089 18.643)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyLightSearch);
export default __webpack_public_path__ + "static/media/Iconly-Light-Search.1eb3c212ed45401e5d4e486d9ad82807.svg";
export { ForwardRef as ReactComponent };